import React, { useState } from 'react';

const IPOServices = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with IPO Services.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with IPO Services.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              IPO Services
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Comprehensive Initial Public Offering (IPO) advisory services to guide companies through the complex process of going public. Our expertise ensures successful listing on stock exchanges with optimal valuation and regulatory compliance.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">📈</span> Start Your IPO Journey
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Our Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">What We Need</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of IPO Services
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Professional IPO services provide comprehensive guidance to companies seeking to go public and list their shares on stock exchanges. Our IPO advisory covers the entire process from pre-IPO preparation to post-listing compliance, ensuring a smooth transition from private to public company.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our comprehensive IPO services include readiness assessment, regulatory compliance, financial restructuring, due diligence, document preparation, merchant banker coordination, and investor roadshows. We work closely with SEBI, stock exchanges, and other regulatory bodies to ensure seamless listing process.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Whether you're planning a mainboard IPO on NSE/BSE or considering SME platform listing, our experienced IPO advisors provide strategic guidance to maximize valuation, ensure regulatory compliance, and create sustainable value for shareholders post-listing.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">IPO Readiness Assessment:</strong> Comprehensive evaluation of company's preparedness for public listing and identification of gaps.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Regulatory Compliance:</strong> Expert guidance on SEBI regulations, Companies Act, and stock exchange listing requirements.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Financial Restructuring:</strong> Optimization of capital structure and financial systems for public company requirements.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Valuation Advisory:</strong> Scientific valuation methodologies to determine optimal IPO price band and maximize valuation.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Documentation Management:</strong> End-to-end management of DRHP, RHP, and other statutory documents preparation.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Stakeholder Coordination:</strong> Seamless coordination with merchant bankers, legal counsel, auditors, and regulators.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Post-IPO Support:</strong> Ongoing compliance advisory and investor relations support after listing.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with IPO Services." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for IPO Success
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "📋", title: "IPO Readiness Assessment", desc: "Comprehensive evaluation of company's preparedness for IPO including financial, legal, and operational aspects." },
              { number: "02", icon: "⚙️", title: "Corporate Restructuring", desc: "Optimization of corporate structure, capital reorganization, and implementation of public company governance." },
              { number: "03", icon: "📄", title: "Due Diligence", desc: "Comprehensive legal, financial, and business due diligence to identify and resolve issues before filing." },
              { number: "04", icon: "✍️", title: "DRHP Preparation", desc: "Drafting and finalizing Draft Red Herring Prospectus with merchant bankers and legal counsel." },
              { number: "05", icon: "🛡️", title: "Regulatory Approvals", desc: "Filing with SEBI, responding to observations, and obtaining necessary regulatory clearances." },
              { number: "06", icon: "👥", title: "Investor Roadshows", desc: "Organizing investor meetings, presentations, and marketing the IPO to institutional and retail investors." },
              { number: "07", icon: "💰", title: "Pricing & Allotment", desc: "Finalizing price band, book building process, share allotment, and refund processing." },
              { number: "08", icon: "🏆", title: "Listing & Beyond", desc: "Stock exchange listing, trading commencement, and post-IPO compliance and investor relations support." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Information We Need
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Essential IPO Documentation
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "📄", title: "Financial Statements", desc: "Audited financial statements for last 5 years, including balance sheets, P&L statements, cash flows, and audit reports." },
              { icon: "💼", title: "Business Plan", desc: "Detailed business plan with growth strategy, market analysis, competitive landscape, and future projections." },
              { icon: "🏢", title: "Corporate Documents", desc: "MOA, AOA, incorporation certificates, board resolutions, and shareholding pattern details." },
              { icon: "🛡️", title: "Legal & Compliance", desc: "All legal agreements, litigation details, regulatory approvals, and compliance certificates." },
              { icon: "👥", title: "Management Information", desc: "Detailed profiles of promoters, directors, and key management personnel with background verification." },
              { icon: "📊", title: "Financial Projections", desc: "Detailed financial projections for next 3-5 years with assumptions and sensitivity analysis." },
              { icon: "✅", title: "Tax Records", desc: "Income tax returns, GST registrations, tax assessment orders, and transfer pricing documentation." },
              { icon: "📋", title: "Operational Details", desc: "Plant and machinery details, property documents, intellectual property, and key customer contracts." },
              { icon: "📈", title: "Industry Analysis", desc: "Market research, industry reports, competitor analysis, and regulatory environment assessment." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "📄", title: "IPO Readiness Report", desc: "Comprehensive assessment of IPO preparedness with gap analysis and implementation roadmap." },
              { icon: "✍️", title: "DRHP Documentation", desc: "Complete Draft Red Herring Prospectus preparation and management through regulatory approvals." },
              { icon: "💰", title: "Valuation Analysis", desc: "Scientific valuation report with optimal price band recommendation and peer comparison analysis." },
              { icon: "👥", title: "Investor Presentation", desc: "Compelling investor presentation materials and roadshow strategy for maximum subscription." },
              { icon: "🎧", title: "Post-IPO Support", desc: "Listing compliance advisory, investor relations support, quarterly reporting guidance, and corporate governance framework" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      IPO Services FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "What are the key eligibility criteria for a mainboard IPO in India?", 
                    answer: "Mainboard IPO eligibility typically includes: 1) Net tangible assets of ₹3 crore in each of preceding 3 years, 2) Track record of distributable profits for 3 out of 5 years, 3) Net worth of ₹1 crore in each of 3 years, or 4) Issue size minimum of ₹10 crore. Alternative routes include QIB book building with 75% subscription." 
                  },
                  { 
                    question: "How long does the entire IPO process typically take?", 
                    answer: "The IPO process typically takes 6-9 months from initial preparation to listing. This includes 2-3 months for pre-IPO restructuring and due diligence, 2-3 months for DRHP preparation and SEBI approval, and 1-2 months for investor roadshows, pricing, and listing. SME IPOs may be faster at 4-6 months." 
                  },
                  { 
                    question: "What are the main costs involved in an IPO?", 
                    answer: "IPO costs typically include merchant banker fees (2-4% of issue size), legal fees (₹50 lakhs-₹2 crores), auditor fees, registrar fees, advertising expenses (₹2-5 crores), stock exchange listing fees, and underwriting commissions. Total costs typically range from 4-8% of the issue size excluding underwriting." 
                  },
                  { 
                    question: "What is the difference between mainboard and SME IPO?", 
                    answer: "Mainboard IPOs are for larger companies with stricter eligibility criteria and post-listing compliance. SME IPOs are for smaller enterprises with simplified norms, lower costs, and market makers for liquidity. Issue size for SME IPOs is typically ₹10-25 crores, while mainboard IPOs have no upper limit." 
                  },
                  { 
                    question: "Can loss-making companies launch an IPO?", 
                    answer: "Yes, loss-making companies can launch IPOs through the QIB book-building route where 75% of the issue is allocated to Qualified Institutional Buyers. Such companies need to meet alternative criteria like net worth requirements and demonstrate future profitability potential to investors." 
                  },
                  { 
                    question: "What post-listing compliance requirements should companies expect?", 
                    answer: "Post-listing compliance includes quarterly financial reporting, corporate governance requirements, disclosure of material events, related party transaction approvals, shareholding pattern disclosures, and annual general meetings. Companies must also maintain minimum public shareholding and comply with SEBI takeover regulations." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready to Go Public?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our experienced IPO advisors guide you through the complex process of going public and maximize your company's valuation while ensuring regulatory compliance.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📈</span> Start Your IPO Journey Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default IPOServices;